import React from 'react';

import PDRCircles from '../../../images/pdr-circles.png';

const HeadWrapper = (props) => (
	<>
    	<html lang="en" prefix="og: http://ogp.me/ns#" />
    	<meta charSet="UTF-8" />
    	<meta name="viewport" content="width=device-width, initial-scale=1.0" />
    	<meta httpEquiv="X-UA-Compatible" content="ie=edge" />
		
		<title>
		{props.title ? (
			<>{props.title} — The Public Domain Review</>
		) : 'The Public Domain Review – Online journal dedicated to showcasing the most interesting and unusual out-of-copyright works available on the web'}
		</title>
	
    	<link href="https://fonts.googleapis.com/css?family=Open+Sans:300,400,600|Alegreya:400,400i,500,500i,700,700i&display=swap" rel="stylesheet" /> 
	
    	<link rel="apple-touch-icon" sizes="57x57" href="/apple-icon-57x57.png" />
    	<link rel="apple-touch-icon" sizes="60x60" href="/apple-icon-60x60.png" />
    	<link rel="apple-touch-icon" sizes="72x72" href="/apple-icon-72x72.png" />
    	<link rel="apple-touch-icon" sizes="76x76" href="/apple-icon-76x76.png" />
    	<link rel="apple-touch-icon" sizes="114x114" href="/apple-icon-114x114.png" />
    	<link rel="apple-touch-icon" sizes="120x120" href="/apple-icon-120x120.png" />
    	<link rel="apple-touch-icon" sizes="144x144" href="/apple-icon-144x144.png" />
    	<link rel="apple-touch-icon" sizes="152x152" href="/apple-icon-152x152.png" />
    	<link rel="apple-touch-icon" sizes="180x180" href="/apple-icon-180x180.png" />
    	<link rel="icon" type="image/png" sizes="192x192"  href="/android-icon-192x192.png" />
    	<link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
    	<link rel="icon" type="image/png" sizes="96x96" href="/favicon-96x96.png" />
    	<link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
    	<meta name="msapplication-TileColor" content="#ffffff" />
    	<meta name="msapplication-TileImage" content="/ms-icon-144x144.png" />
    	<meta name="theme-color" content="#ffffff" />
	
    	<meta
			id="metaTitle"
			name="title"
			content="The Public Domain Review – Online journal dedicated to showcasing the most interesting and unusual out-of-copyright works available on the web"
		/>
    	<meta
			id="metaDescription"
			name="description"
			content="Online journal and not-for-profit project dedicated to the exploration of curious and compelling works from the history of art, literature, and ideas."
		/>
	
    	<meta
			id="ogTitle"
			property="og:title"
			content="The Public Domain Review"
    	/>
    	<meta
			id="ogImage"
			property="og:image"
			content={ PDRCircles }
    	/>
    	<meta
			id="ogDescription"
			property="og:description"
			content="Online journal and not-for-profit project dedicated to the exploration of curious and compelling works from the history of art, literature, and ideas."
    	/>
    	<meta
			id="ogType"
			property="og:type"
			content="website"
    	/>
    	<meta
			id="ogUrl"
			property="og:url"
			content="https://publicdomainreview.org"
    	/>
    	<meta
			id="ogSiteName"
			property="og:site_name"
			content="The Public Domain Review"
    	/>

		{props.children}
	</>
);

export default HeadWrapper;